<template>
    <div>
        <v-dialog
            v-model="createAdOverlay"
            content-class="create-ad-con"
            :overlay-opacity="opacity"
            :persistent="true"
            :hide-overlay="true"
        >
            <div
                class="create-ad-card"
                @dragenter.prevent="dragEnter"
                @dragleave.prevent="dragLeave"
                @dragover.prevent
                @drop.prevent
            >
                <!-- header part  -->
                <div class="flex header">
                    <div class="flex">
                        <v-icon
                            @click="handleBackbtn"
                            class="icon"
                            color="#1F8F58"
                            size="25"
                        >
                            mdi-arrow-left
                        </v-icon>
                        <h3 class="header-text">Create your advertisement</h3>
                    </div>
                   
                </div>

                <!-- campaign name  -->
                <!-- <button @click="getImageOrVideoConfig()">bjkb</button> -->
                <div
                    class="after-click-createAd"
                    v-for="form in forms"
                    :key="form.order"
                >
                    <v-icon
                        v-if="forms.length > 1"
                        color="#D93D3D"
                        size="25"
                        class="delete-form pointer"
                        @click="removeForm(form.order)"
                    >
                        mdi-close
                    </v-icon>
                    <v-text-field
                        v-model="form.adName"
                        :light="true"
                        outlined
                        placeholder="Add your advertisement name here"
                        color="#121212"
                        hide-details="true"
                        style="margin-right: 5px"
                    ></v-text-field>

                    <!-- CTA fields  -->
                    <div class="flex form-input">
                        <v-select
                            :light="true"
                            :items="CTAConfigs"
                            item-text="display_name"
                            item-value="display_name"
                            v-model="form.CTAtext"
                            placeholder="CTA text"
                            hide-details="true"
                            outlined
                            style="width: 100%"
                        ></v-select>

                        <div
                            v-if="
                                dataforApi.campaign_objective ==
                                    'lead_generation' ||
                                dataforApi.campaign_objective ==
                                    'farmer_discovery'
                            "
                            style="width: 100%"
                        ></div>
                        <div style="width: 100%" v-else>
                            <v-text-field
                                v-model="form.ctaDestination"
                                :light="true"
                                outlined
                                placeholder="CTA destination"
                                hide-details="true"
                                color="#121212"
                                style="width: 100%"
                            ></v-text-field>
                        </div>
                    </div>
                    <div class="flex cta_input">
                        <div class="flex"></div>
                        <div class="flex">
                            <p v-if="form.showerror" class="error_msg">
                                * This field must be a valid phone number
                            </p>
                        </div>
                    </div>
                    <!-- text area for message  -->
                    <div class="form-input">
                        <v-textarea
                            height="129"
                            v-model="form.messageText"
                            :light="true"
                            :items="items"
                            placeholder="Write your message here"
                            hide-details="true"
                            outlined
                        />
                    </div>
                    <div style="margin-top: 10px">
                        <v-select
                            v-model="form.card_size"
                            :light="true"
                            :items="card_size_list"
                            item-text="display_text"
                            item-value="id"
                            placeholder="Enter your card size here"
                            hide-details="true"
                            outlined
                            color="#121212"
                            style="width: 100%"
                        ></v-select>
                    </div>

                    <!-- image drop zone  -->
                    <div
                        class="flex drop-zone"
                        @drop.prevent="dropImages($event, form)"
                    >
                        <!-- input image on button click  -->
                        <input                        
                            type="file"
                            ref="imageUploader"
                            :id="form.order"
                            :name="form.order"
                            style="display: none"
                            multiple
                            accept="image/*,video/*"
                            @change="selectImages($event)"
                        />

                        <p>
                            Drop and drop your file here or
                            <label
                                @click="currentForm = form"
                                :for="form.order"
                                class="flex --green pointer"
                            >
                                click here</label
                            >
                        </p>
                        <p>to upload .png, .jpg, .mp4 files supported</p>

                        <div class="images-preview-container flex">
                            <div
                                v-for="(image, index) in form.imagePreviews"
                                :key="index"
                            >
                                <div
                                    class="preview-image"
                                    v-if="form.media_type == 'image'"
                                >
                                    <img :src="image.url" />
                                    <v-icon
                                        class="delete-image pointer"
                                        color="white"
                                        size="22"
                                        @click.passive="
                                            removeSelectedImage(
                                                $event,
                                                index,
                                                form
                                            )
                                        "
                                    >
                                        mdi-close
                                    </v-icon>
                                </div>
                                <div
                                    class="preview-video"
                                    v-if="form.media_type == 'video'"
                                >
                                    <video
                                        :id="verticalID + form.order"
                                        autoplay
                                        muted
                                        :src="form.imagePreviews"
                                        class="videoPreview"
                                    ></video>
                                    <v-icon
                                        class="video-image pointer"
                                        color="white"
                                        size="22"
                                        @click.passive="
                                            removeSelectedImage(
                                                $event,
                                                index,
                                                form
                                            )
                                        "
                                    >
                                        mdi-close
                                    </v-icon>
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr v-if="forms.length > 1" class="hrline" />
                </div>

                <v-btn
                    color="#EBF5F0"
                    class="create-ad-btn"
                    elevation="0"
                    x-large
                    block
                    @click="addForm"
                    :loading="videoIsUploading"
                >
                    + create new ad
                </v-btn>

                <!-- button section  -->
                <div class="button-section flex">
                    <v-btn
                        @click="handleCancelClick"
                        elevation="0"
                        class="cancel-btn"
                        color="#EBF5F0"
                    >
                        Cancel
                    </v-btn>

                    <v-btn
                        :loading="imageApicall"
                        :disabled="disableNext || disableNextButton"
                        @click="handleNextClick"
                        elevation="0"
                        class="next-btn"
                        color="#1D8D56"
                    >
                        Next
                    </v-btn>
                </div>
            </div>
        </v-dialog>
        <success-page
            :type="successType"
            :successOverlay="successOverlay"
            @closeAll="closeAll"
        />
    </div>
</template>

<script>
import helper from "../../../../helpers/methods";
import successPage from "./success-page.vue";
import accessToken from "../../../../helpers/accessToken";
import API_URL from "../../../../helpers/apiUrls";

export default {
    name: "createAdvertisement",
    components: {
        "success-page": successPage,
    },
    data() {
        return {
            opacity: 0,
            items: ["Foo", "Bar", "Fizz", "Buzz"],
            count: 1,
            successType: "published",
            forms: [
                {
                    order: 1,
                    adName: "",
                    CTAtext: "",
                    ctaDestination: "",
                    messageText: "",

                    imagePreviews: [],
                    images: [],
                    createAdKey: false,
                    imageSelectionLimit: 1,
                    imageLink: "",
                    media_type: "",
                    showerror: false,
                    card_size: null,
                },
            ],
            currentForm: {},
            currFormId: 0,
            isDragged: false,
            //video
            uploadConfigs: {},
            maxVideoDuration: null,
            bucketPath: null,
            bucketName: "",
            expiryTime: null,
            videoID: null,
            videoFileName: "",
            videoSize: null,
            eTags: [],
            uploadID: null,
            keyName: null,
            parts: 0,
            videoSize: 0,
            imageThumbnail: null,
            temporaryVideoPreview: null,
            videoPreview: null,

            // --
            successOverlay: false,
            currentImageLink: "",

            formData: [],
            dataforApi: this.data,
            apicall: false,
            imageApicall: false,
            videoIsUploading: false,
            verticalID: "verticalID",

            campaignObjective: "",
            selectedLanguage: "",
            CTAConfigs: [],
            createAdDialog: this.createAdOverlay,
            formID: "",
            showErrorOrNot: false,

            card_size_list: [],
            productId : "",
            disableNextButton : false,
        };
    },
    props: {
        createAdOverlay: Boolean,
        data: Object,
        cardSize: Array,
        fromEditpage : Boolean,
        product : Object,
    },
    mounted() {
        console.log("CREATE AD MOUNTED",this.product);
        this.getCTAConfigs();
        this.getImageOrVideoConfig();
        console.log("DATA FOR API HERE 99999999--->", this.dataforApi);
        this.card_size_list = this.cardSize;

        if (this.dataforApi.campaign_objective === "lead_generation") {
            this.formID = this.dataforApi.form;
            console.log("GERformID:", this.formID);
        }

        if(this.product){
            console.log("THISPROD", this.product);
            if(this.product.id){
                this.forms[0].ctaDestination = this.product.id;
                this.productId = this.product.id;
            } else{
                this.forms[0].ctaDestination = this.product;
                this.productId = this.product;            
            }

        }
    },

    computed: {
        disableNext() {
            console.log("this.forms.length", this.forms.length, this.forms);
            // const flag;
            for (var i = 0; i < this.forms.length; i++) {
                console.log("ITEM", this.forms[i], i);
                if (
                    !this.forms[i].CTAtext ||
                    !this.forms[i].imageLink ||
                    !this.forms[i].messageText ||
                    !this.forms[i].adName ||
                    !this.forms[i].card_size
                ) {
                    return true;
                }
            }
            return false;
        },
    },
    watch: {
        createAdOverlay: function () {
            this.campaignObjective = this.dataforApi.campaign_objective;
            this.selectedLanguage = this.dataforApi.language_id;
            this.dataforApi = this.data;
            console.log("DATA FOR API HERE 99999999--->", this.dataforApi);

            console.log(
                "campaignObjective",
                this.campaignObjective,
                this.selectedLanguage
            );
            this.getCTAConfigs();
            this.getImageOrVideoConfig();
        },
    },

    methods: {
        handleBackbtn() {
            this.$emit("closeCreateAdOverlay");
        },
        handleCancelClick() {
            this.$emit("cancelAdCreation");
        },
        closeAll(){
            this.successOverlay = false;
            this.$emit("closeAll");
        },
        getCTAConfigs() {
            console.log("CALLED-->");
            this.campaignObjective = this.dataforApi.campaign_objective;
            this.selectedLanguage = this.dataforApi.language_id;
            const successHandler = (response) => {
                if (response.status === 200) {
                    console.log("CTAConfigs RESPONSE", response.data);
                    this.CTAConfigs = response.data;
                }
            };
            const errorHandler = (response) => {
                this.showToast(
                    "Something went wrong internally!",
                    "error",
                    10000
                );
            };

            const headers = {
                Authorization: `Bearer ${accessToken.getAccessToken()}`,
            };
            this.requestGET(
                `${API_URL.getCTAlist}?campaign_objective=${this.campaignObjective}&language=${this.selectedLanguage}`,
                {},
                headers,
                successHandler,
                errorHandler
            );
        },
        //config for video upload
        getImageOrVideoConfig() {
            console.log("HELLO FROM VIDEO XON");
            this.toggleLoader(true);
            const successHandler = (response) => {
                if (response.status === 200) {
                    console.log(
                        "video config",
                        response.data.configs
                            .brand_krishi_clips_video_upload_config
                    );
                    this.uploadConfigs =
                        response.data.configs.brand_krishi_clips_video_upload_config;
                    this.toggleLoader(false);
                }
            };

            const errorHandler = (response) => {
                this.showToast(
                    "Something went wrong internally!",
                    "error",
                    10000
                );
            };

            const headers = {
                Authorization: `Bearer ${accessToken.getAccessToken()}`,
                "BRAND-ID": localStorage.getItem("Brand-ID"),
            };

            this.requestGET(
                API_URL.createContent__getImageOrVideoConfigs,
                {},
                headers,
                successHandler,
                errorHandler
            );
        },

        //  call post api on next button click
        handleNextClick() {
            var phoneNumPattern = new RegExp(
                /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
            );
            this.showErrorOrNot = false;
            for (var i = 0; i < this.forms.length; i++)
                this.forms[i].showerror = false;

            if (this.data.campaign_objective == "click_to_call") {
                for (var i = 0; i < this.forms.length; i++) {
                    if (!this.forms[i].ctaDestination.match(phoneNumPattern)) {
                        this.forms[i].showerror = true;
                        this.showErrorOrNot = true;
                    }
                }
                console.log("HEUREO");
            }

            if (this.showErrorOrNot) {
                console.log("HEUREO2");
            } else {
                this.apicall = true;
                this.forms.forEach(async (item, index) => {
                    const data = {};
                    data.name = item.adName;
                    data.description = item.messageText;
                    data.cta_text = item.CTAtext;
                    data.card_size = parseFloat(item.card_size);

                    if (
                        this.dataforApi.campaign_objective ===
                            "lead_generation" ||
                        this.dataforApi.campaign_objective ===
                            "farmer_discovery"
                    ) {
                        data.cta_destination = this.formID;
                    } else {
                        data.cta_destination = item.ctaDestination;
                    }

                    if (item.media_type == "image") {
                        data.image = item.imageLink;
                    } else if (item.media_type == "video") {
                        data.video = item.imageLink;
                    }

                    this.formData.push(data);
                });

                this.dataforApi.ads = this.formData;
                console.log("FOMRMS,", this.forms);

                if(this.fromEditpage){
                    this.$emit("closeCreateAdOverlay");
                    this.$emit("adData", this.formData)
                } else {
                    this.createcampaign();
                }
            }
        },

        // remove selected image on cross mark
        selectImages(event) {
            const form = this.currentForm;
            console.log("selectImages", event.target.files[0]);
            if (event.target.files[0].type.includes("video")) {
                this.videoIsUploading = true;
                this.forms[form.order - 1].media_type = "video";
                console.log("video", event.target.files[0]);
                const size = (
                    event.target.files[0].size /
                    (1024 * 1024)
                ).toFixed(2);
                const actualSize = helper.getFormatedSizeofVideoinMb(size);
                //console.log('size',size,actualSize,this.uploadConfigs.max_video_size_in_mb);
                if (
                    parseFloat(
                        this.uploadConfigs.max_video_size_in_mb
                            ? this.uploadConfigs.max_video_size_in_mb
                            : 35
                    ) < size
                ) {
                    this.showToast(
                        "Video size should not be greater than 35 Mb",
                        "error",
                        2000
                    );
                    this.videoIsUploading = false;
                    return;
                } else {
                    this.videoFileName = event.target.files[0].name;
                    this.temporaryVideoPreview = URL.createObjectURL(
                        event.target.files[0]
                    );
                    this.videoPreview = this.temporaryVideoPreview;
                    const videoPreviewArr = [];
                    videoPreviewArr.push(this.videoPreview);
                    this.forms[form.order - 1].imagePreviews = videoPreviewArr;
                    //   console.log("VIDEO PREVIEW -->", this.videoPreview, form);

                    this.videoSize = size;
                    const videoChunks = helper.createVideoChunks(
                        event.target.files[0],
                        10,
                        actualSize
                    );
                    this.getPresignedURLs(event, videoChunks);
                }
            } else {
                this.currFormId = this.currentForm.order;
                this.forms[form.order - 1].media_type = "image";
                if (form.imagePreviews.length + 1 > form.imageSelectionLimit)
                    this.showToast(
                        `You can only select ${form.imageSelectionLimit} images for this post. Please try again!`,
                        "error",
                        10000
                    );
                else {
                    Array.from(event.target.files).forEach((file) => {
                        form.images.push(file);
                        this.uploadImage(file, form.order - 1);
                    });
                    form.imageLink = this.currentImageLink;

                    const thumbnails = helper.provideImagePreviewURL(
                        form.images
                    );
                    const newPreviewArray = thumbnails.map((thumbnail) => {
                        return {
                            id: null,
                            url: thumbnail,
                        };
                    });
                    if (this.type === "edit")
                        form.imagePreviews = [
                            ...form.imagePreviews,
                            ...newPreviewArray,
                        ];
                    else form.imagePreviews = newPreviewArray;
                    event.target.value = "";
                }
            }
        },

        // remove selected image from preview
        removeSelectedImage(event, index, form) {
            console.log("removeSelectedImage", event);
            console.log("this.forms[form.index]", form, this.forms);
                     this.forms[form.order - 1].imageLink = "";
            form.imagePreviews = form.imagePreviews.filter(
                (image) => image != form.imagePreviews[index]
            );
            form.images = Array.from(form.images).filter(
                (image) => image != form.images[index]
            );
            // form.createAdKey = !form.createAdKey;
            this.$refs.imageUploader.value = "";
            if (form.media_type == "video" && this.videoIsUploading) {
                console.log("IN KWIURWIHRHFKJWKFHKJFNKWJKJW");
                this.abortVideoUploadRequest();
            }
        },

        // generate preview for drop image
        dropImages(event, form) {
            this.currentForm = form;
            console.log("dropImages", event.dataTransfer.files[0]);
            if (event.dataTransfer.files[0].type.includes("video")) {
                console.log('"HERE');
                this.videoIsUploading = true;
                this.forms[form.order - 1].media_type = "video";
                console.log("video", event.dataTransfer.files[0]);
                const size = (
                    event.dataTransfer.files[0].size /
                    (1024 * 1024)
                ).toFixed(2);
                const actualSize = helper.getFormatedSizeofVideoinMb(size);
                //console.log('size',size,actualSize,this.uploadConfigs.max_video_size_in_mb);
                if (
                    parseFloat(
                        this.uploadConfigs.max_video_size_in_mb
                            ? this.uploadConfigs.max_video_size_in_mb
                            : 35
                    ) < size
                ) {
                    this.showToast(
                        "Video size should not be greater than 35 Mb",
                        "error",
                        2000
                    );
                    return;
                } else {
                    this.videoFileName = event.dataTransfer.files[0].name;
                    this.temporaryVideoPreview = URL.createObjectURL(
                        event.dataTransfer.files[0]
                    );
                    this.videoPreview = this.temporaryVideoPreview;
                    const videoPreviewArr = [];
                    videoPreviewArr.push(this.videoPreview);
                    this.forms[form.order - 1].imagePreviews = videoPreviewArr;
                    console.log("VIDEO PREVIEW -->", this.videoPreview, form);

                    this.videoSize = size;
                    const videoChunks = helper.createVideoChunks(
                        event.dataTransfer.files[0],
                        10,
                        actualSize
                    );
                    this.getPresignedURLs(event, videoChunks);
                }
            } else {
                if (form.imagePreviews.length + 1 > form.imageSelectionLimit) {
                    this.showToast(
                        `You can only select ${form.imageSelectionLimit} images for this post. Please try again!`,
                        "error",
                        10000
                    );
                } else {
                    Array.from(event.dataTransfer.files).forEach((file) => {
                        form.images.push(file);
                        this.uploadImage(file, form.order - 1);
                    });
                    form.imageLink = this.currentImageLink;

                    const thumbnails = helper.provideImagePreviewURL(
                        form.images
                    );
                    const newPreviewArray = thumbnails.map((thumbnail) => {
                        return {
                            id: null,
                            url: thumbnail,
                        };
                    });

                    form.imagePreviews = newPreviewArray;
                }
            }
        },

        dragEnter() {
            this.isDragged = true;
        },
        dragLeave() {
            this.isDragged = false;
        },

        // create a new form on add new click
        addForm() {
            this.forms.push({
                order: this.forms.length + 1,
                adName: "",
                CTAtext: "",
                ctaDestination: this.productId,
                messageText: "",
                imagePreviews: [],
                images: [],
                createAdKey: false,
                imageSelectionLimit: 1,
                imageLink: "",
                media_type: "",
                showerror: false,
                card_size: null,
            });
        },
        removeForm(order) {
            if (order == this.forms.length) {
                this.forms = this.forms.filter((form) => {
                    return form.order != order;
                });
            }

            if (order < this.forms.length) {
                for (let i = 0; i < this.forms.length; i++) {
                    if (this.forms[i].order == order) {
                        this.forms = this.forms.filter((form) => {
                            return form.order != order;
                        });
                    }
                    if (this.forms[i].order > order) {
                        this.forms[i].order--;
                        console.log("RemoveForm", this.forms);
                    }
                }
            }
        },
        // upload image and generate id
        uploadImage(image, index) {
            this.imageApicall = true;
            console.log("this.forms", this.forms, index);
            const successHandler = (response) => {
                if (response.status === 200) {
                    this.imageApicall = false;
                    this.forms[index].imageLink = response.data.id;
                    console.log("this.forms--->", this.forms);
                }
            };

            const errorHandler = (error) => {
                this.showToast(
                    "Something went wrong internally.",
                    "error",
                    10000
                );
                this.loader = false;
            };
            const data = new FormData();
            data.append("image", image);

            const headers = {
                Authorization: `Bearer ${accessToken.getAccessToken()}`,
            };

            this.requestPOST(
                API_URL.imageUpload,
                data,
                headers,
                successHandler,
                errorHandler
            );
        },

        // create new campaign call
        createcampaign() {
            this.apicall = true;
            this.disableNextButton = true;
            const successHandler = (response) => {
                if (response.status === 200) {
                    console.log("CAMPAIGN CREATE RESPONSE *******", response);
                    this.successOverlay = true;
                }
            };

            const errorHandler = (error) => {
                this.showToast(
                    "Something went wrong internally",
                    "error",
                    10000
                );
                this.apicall = false;
                this.disableNextButton = false;
            };

            const headers = {
                Authorization: `Bearer ${accessToken.getAccessToken()}`,
            };
            console.log("DATA FOR API AD CREATION ---->", this.dataforApi);
            this.requestPOST(
                API_URL.createCampaign,
                this.dataforApi,
                headers,
                successHandler,
                errorHandler
            );
        },

        //video apis flow start

        getPresignedURLs(event, videoChunks) {
            const form = this.currentForm;
            const successHandler = (response) => {
                if (response.status === 200) {
                    console.log("getPresignedURLs", response.data);
                    this.uploadVideo(response.data.url_list, videoChunks);
                    this.uploadID = response.data.upload_id;
                    this.keyName = response.data.key_name;
                    this.parts = response.data.parts;
                    event.target.value = "";
                }
            };

            const errorHandler = (error) => {
                console.log("HEHRHOFEKVKJ_>");
                this.videoIsUploading = false;
                this.forms[form.order - 1].imagePreviews = [];
                console.log(
                    "this.forms[form.order - 1].imagePreviews",
                    this.forms[form.order - 1].imagePreviews
                );

                this.showToast(
                    "Something went wrong internally, aborting video upload...",
                    "error",
                    10000
                );
                console.log(error);
            };

            const headers = {
                Authorization: `Bearer ${accessToken.getAccessToken()}`,
                "BRAND-ID": localStorage.getItem("Brand-ID"),
            };

            this.uploadConfigs.file_format = `.${
                event.dataTransfer
                    ? event.dataTransfer.files[0].type.split("/")[1]
                    : event.target.files[0].type.split("/")[1]
            }`;

            this.uploadConfigs.size_in_mb = this.videoSize;
            console.log(this.videoSize);

            this.requestGET(
                API_URL.createContent__getVideoPresignedURLs,
                this.uploadConfigs,
                headers,
                successHandler,
                errorHandler
            );
        },
        uploadVideo(urls, videoChunks) {
            const form = this.currentForm;
            urls.forEach((url, index) => {
                const successHandler = (response) => {
                    if (response.status === 200) {
                        this.eTags.push({
                            ETag: response.headers.etag,
                            PartNumber: url.part_no,
                        });
                        if (urls.length - 1 === index) {
                            setTimeout(this.informS3AboutVideoUpload(), 3000);
                        }
                    }
                };

                const errorHandler = (error) => {
                    //   this.showToast(
                    //     "Something went wrong internally, aborting video upload...",
                    //     "error",
                    //     10000
                    //   );
                    this.videoIsUploading = false;
                    this.forms[form.order - 1].imagePreviews = [];

                    console.log(error);
                    this.abortVideoUploadRequest();
                    return;
                };

                // const data = new FormData();
                // data.append('file', videoChunks[index]);
                const file = videoChunks[index];

                this.requestPUT(
                    url.url,
                    file,
                    {},
                    successHandler,
                    errorHandler
                );
            });
        },
        // this will be called one time only after getting the etags array
        informS3AboutVideoUpload() {
            const successHandler = (response) => {
                if (response.status === 200) {
                    console.log("informS3AboutVideoUpload", response.data);
                    this.registerVideoInBackend(response.data.Key);
                }
            };

            const errorHandler = (error) => {
                this.videoIsUploading = false;
                this.forms[form.order - 1].imagePreviews = [];
                console.log(error);
                this.showToast(
                    "Something went wrong internally, aborting video upload...",
                    "error",
                    10000
                );
                this.abortVideoUploadRequest();
            };

            const headers = {
                Authorization: `Bearer ${accessToken.getAccessToken()}`,
                "BRAND-ID": localStorage.getItem("Brand-ID"),
            };

            const data = {
                bucket_name: this.uploadConfigs.bucket_name,
                upload_id: this.uploadID,
                key_name: this.keyName,
                parts: this.lodash.sortBy(this.eTags, "PartNumber"),
            };

            this.requestPOST(
                API_URL.createContent__uploadComplete,
                data,
                headers,
                successHandler,
                errorHandler
            );
        },
        //abc
        registerVideoInBackend(key) {
            const form = this.currentForm;
            console.log("registerVideo", key, form.order);
            var video = document.getElementById(this.verticalID + form.order);
            console.log("getVideo", video);
            const successHandler = (response) => {
                if (response.status === 201) {
                    console.log("registerVideoInBackend", response.data);

                    this.forms[form.order - 1].imageLink = response.data.id;
                    this.videoIsUploading = false;

                    this.bucketPath = null;
                    this.bucketName = "";
                    this.expiryTime = null;
                    this.videoID = null;
                    this.videoFileName = "";
                    this.videoSize = null;
                    this.eTags = [];
                    this.uploadID = null;
                    this.keyName = null;
                    this.parts = 0;
                    this.videoSize = 0;
                    this.imageThumbnail = null;
                    this.temporaryVideoPreview = null;
                    this.videoPreview = null;

                    // this.videoID = response.data.id;
                    // this.showToast("The video has been successfully uploaded!");

                    //   this.videoPreview = this.temporaryVideoPreview;
                    //this.eTags = [];
                }
            };

            const errorHandler = (error) => {
                console.log(error);
                console.log(error.response);
                this.videoIsUploading = false;
                this.forms[form.order - 1].imagePreviews = [];
                this.showToast(
                    "Something went wrong internally, aborting video upload...",
                    "error",
                    10000
                );
                this.abortVideoUploadRequest();
            };
            console.log("FORM _ODER", form.order);
            var video = document.getElementById(this.verticalID + form.order);
            console.log("VIDEO->", video);
            this.imageThumbnail = helper.generateVideoThumbnail(
                video,
                this.videoFileName
            );

            const data = new FormData();
            const videoID = key.split(".")[0];
            /* This is should be ideally generated in backend */
            data.append("video_id", videoID);
            data.append("video_path", key);
            data.append("orientation", "portrait");
            data.append("image", this.imageThumbnail);

            const headers = {
                Authorization: `Bearer ${accessToken.getAccessToken()}`,
                "BRAND-ID": localStorage.getItem("Brand-ID"),
            };

            this.requestPOST(
                API_URL.createContent__registerVideo,
                data,
                headers,
                successHandler,
                errorHandler
            );
        },
        abortVideoUploadRequest() {
            this.videoIsUploading = true;
            const successHandler = (response) => {
                if (response.status === 200) {
                    this.videoUploadingProcess = 0;
                    this.temporaryVideoPreview = null;
                    this.videoPreview = null;
                    this.videoIsUploading = false;
                }
            };

            const errorHandler = (error) => {
                this.showToast(
                    "Something went wrong internally!",
                    "error",
                    10000
                );
                console.log(error);
            };

            const headers = {
                Authorization: `Bearer ${accessToken.getAccessToken()}`,
                "BRAND-ID": localStorage.getItem("Brand-ID"),
            };

            const data = {
                bucket_name: this.uploadConfigs.bucket_name,
                upload_id: this.uploadID,
                key_name: this.keyName,
            };

            this.requestPOST(
                API_URL.createContent__abortVideoUpload,
                data,
                headers,
                successHandler,
                errorHandler
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.create-ad-card {
    padding: 25px;
    color: #333333;
}
/* header ui css  */
.header {
    justify-content: space-between;
    margin-bottom: 20px;
}
.header-text {
    font-weight: 500;
    font-size: 1.2rem;
    color: #333333;
    margin-left: 15px;
}
.icon {
    background-color: #eff6f3;
    padding: 8px;
    border-radius: 6px;
}

/* form fields ui css  */
.form-input {
    column-gap: 40px;
    margin-top: 10px;
    margin-right: 5px;
}

/* drop zone ui  */
.drop-zone {
    flex-direction: column;
    background: #fbfdfc;
    border: 1px dashed #dbdbdb;
    border-radius: 7px;
    margin: 10px 0px 10px;
    padding: 28px 0px;
    color: #c2cbc3;
    position: relative;

    p {
        margin: 0;
    }
}

.images-preview-container {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}
.images-preview-container > div {
    width: 120px;
    height: 120px;
    border-radius: 3px;
}
.videoPreview {
    width: 120px;
    height: 120px;
}
.preview-image {
    height: 124px;
    width: 100%;
    img {
        object-fit: cover;
        width: 100%;
        height: 100%;
    }
}
.preview-video {
    height: 124px;
    video {
        width: auto;
    }
}
.delete-image {
    background-color: rgba(53, 52, 52, 0.47);
    border-radius: 50%;
    transform: translate(90px, -125px);
}
.video-image {
    background-color: rgba(53, 52, 52, 0.47);
    border-radius: 50%;
    transform: translate(175px, -120px);
}
.icon {
    font-size: 6rem;
}

// button section
.create-ad-btn {
    color: #1d8d56;
    font-weight: 600;
    text-transform: capitalize;
    font-size: 1rem;
}
.button-section {
    justify-content: space-between;
    margin-top: 10px;
    .v-btn {
        width: 47%;
        height: 56px !important;
        text-transform: capitalize !important;
        font-size: 1rem;
    }
}
.cancel-btn {
    color: #1d8d56 !important;
    font-size: 1rem;
}
.next-btn {
    color: #ffffff;
    font-size: 1rem;
}
.hrline {
    margin: 20px 0px;
    border: 0.9px solid #1d8d56;
}
.delete-form {
    background-color: #fef7f7;
    height: 38px;
    width: 38px;
    //border-radius: 5px;
    margin-left: 5px;
    margin-bottom: 5px;
}
.cta_input {
    flex-direction: row;
}
.error_msg {
    display: flex;
    color: #af3131;
    font-size: 13px;
    padding-left: 280px;
    margin-bottom: 0px;
}
</style>
<style>
.create-ad-con.v-dialog {
    width: 800px;
    height: 650px;
    background-color: white;
    border-radius: 10px;
    overflow-y: scroll;
    box-shadow: none;
}
.after-click-createAd {
    padding-top: 10px;
}
</style>